import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import type {
  GetDataGroupsRequest,
  GetDataGroupsResponse,
} from "./types";
import { baseQueryCreator } from "redux/baseQuery";
import env from "env";

const { enterpriseService } = env.api.baseUrl;

const baseQuery = fetchBaseQuery({
  baseUrl: enterpriseService,
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as any).auth.accessToken;
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

export const enterpriseApi = createApi({
  reducerPath: "enterpriseApi",
  baseQuery: baseQueryCreator(baseQuery),
  refetchOnMountOrArgChange: true,
  tagTypes: ["Enterprise"],
  endpoints: (builder) => ({
    getDataGroups: builder.query<GetDataGroupsResponse, GetDataGroupsRequest >({
      query: ({dataGroupCodes}) => {
      return {
        url: `data-groups`,
        method: "GET",
       params: {
        dataGroupCodes: dataGroupCodes,
        detailLevel: 'FULL'
       }
      }},
      keepUnusedDataFor: 604800 // 7 days
    }),
  }),
});

export const {
  useGetDataGroupsQuery,
} = enterpriseApi;
